import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-action-nav-bar',
    templateUrl: './action-nav-bar.component.html',
    styleUrls: ['./action-nav-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActionNavBarComponent implements OnInit {

  @Input() showBorder: boolean = true

  constructor() { }

  ngOnInit() {
  }

}
